import { Button, Center, Loader } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons";
import { useNavigate, useParams } from "react-router-dom";
import SurveyJsDashboard from "../SurveyJsDashboard";
import {
    getApiCallGetCallListUser, getApiCallGetStepResultByCall, getApiStepGetStepById,
    useGetApiCallGetStepResultByCall,
    useGetApiStepGetStepById,
} from "../../../api/endpoints";
import { useTranslation } from "react-i18next";
import useApi from "../../../utils/useApi";
import {CallResponse, Step, StepResultResponse} from "../../../api/model";

const ReportByStep = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  
  
  const { stepId, callId } = useParams();

    const {
        data: step,
        setData: setStep,
        loading: isLoadingStep,
        setLoading: setIsLoadingStep,
        error: errorStep,
        setError: setErrorStep,
    } = useApi<Step>(() => getApiStepGetStepById({stepId}), [stepId]);
    const {
        data: results,
        setData: setResults,
        loading: isLoadingResults,
        setLoading: setIsLoadingResults,
        error: errorResults,
        setError: setErrorResults ,
    } = useApi<StepResultResponse[]>(() => getApiCallGetStepResultByCall({
        StepId: stepId,
        callId: callId,
    }), [stepId, callId]);
  
  // const { data: step } = useGetApiStepGetStepById({ stepId });
  // const { data: results } = useGetApiCallGetStepResultByCall({
  //   StepId: stepId,
  //   callId: callId,
  // });
  console.log("STEP: ", isLoadingStep, isLoadingResults, errorResults, errorStep, step, results);
  if (isLoadingStep || isLoadingResults) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }
    if (errorResults || errorStep) {
        return (
            <Center>
                Errore
            </Center>
        );
    }
    if (!results || !step) {
        return (
            <Center>
                Errore caricamento
            </Center>
        );
    }
    console.log(step, results);
  return (
    <>
      <Button
        variant="subtle"
        style={{ marginLeft: -14 }}
        leftIcon={<IconArrowLeft />}
        onClick={() => navigate(-1)}
      >
        {t("pages.admin.section.go-back")}
      </Button>
      <SurveyJsDashboard results={results!} step={step!} />
    </>
  );
};

export default ReportByStep;
